import { Auth } from 'aws-amplify'
import { clearLocalStorageOnLogout } from '@/utils/local-storage'

// ログアウトリンク
export default {
  render() {
    // 何もレンダリングしない
  },
  async created() {
    if (!this.$store.getters['auth/check']) {
      return false
    }

    // ログアウト処理により案件IDがクリアされるため、
    // ログアウト処理前にパスを取得しておく
    const to = this.$wcRouter.path({ name: 'auth.login' })

    // ログアウト処理
    // Auth.signOutではLocalStorageがクリアされなかったため、
    // 以下のメソッドに置き換え
    // @see https://github.com/aws-amplify/amplify-js/issues/614#issuecomment-383407549
    await Auth.userPool.getCurrentUser().signOut()
    this.$store.commit('auth/SET_USER', null)
    this.$store.commit('app/SET_OFFICE_ID', null)
    this.$store.commit('app/SET_CEREMONY_STATUS', '')

    // ローカルストレージのクリア
    clearLocalStorageOnLogout()

    // ログイン画面に移動
    this.$router.push(to)
  }
}
